import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Result from './Result';
import {
  SearcherModal, CloseIcon, SearchInput, ResultsWrapper, Loading, LoadMoreBtn,
} from './styles';

class Searcher extends Component {
  componentDidUpdate() {
    this.slideToBottom();
  }

  printResults = () => {
    const { results, isLoading } = this.props;

    const bubbles = _.map(results, result => (
      <Result result={result} onClick={this.handleClick} key={result.id} />
    ));

    return (
      <React.Fragment>
        {bubbles}
        {isLoading && (<Loading />)}
        <div ref={this.assignRefResultsEnd} />
      </React.Fragment>
    );
  }

  slideToBottom = () => {
    if (this.endResults) {
      this.endResults.scrollIntoView({ behavior: 'smooth' });
    }
  }

  handleClick = (id) => {
    const { viewUserProfile } = this.props;
    viewUserProfile(id);
  }

  handleClose = () => {
    const { onClose } = this.props;

    onClose();
  }

  handleChangeInput = (event) => {
    const { value } = event.target;
    const { setQueryString, search } = this.props;
    setQueryString(value);

    if (this.intSearch) {
      clearTimeout(this.intSearch);
    }

    this.intSearch = setTimeout(() => {
      search();
    }, 1000);
  }

  assignRefResultsEnd = (ref) => {
    this.endResults = ref;
  }

  render() {
    const {
      literals, q, app: { color1: color }, isLoading, search, canLoadMore,
    } = this.props;

    return (
      <SearcherModal color={color}>
        <CloseIcon onClick={this.handleClose}>
          <i className='fa fa-times' />
        </CloseIcon>
        <SearchInput autoFocus value={q} placeholder={literals.search} onChange={this.handleChangeInput} />
        <ResultsWrapper>
          {this.printResults()}
        </ResultsWrapper>
        {!isLoading && canLoadMore && (
          <LoadMoreBtn onClick={search}>{literals.viewMore}</LoadMoreBtn>
        )}
      </SearcherModal>
    );
  }
}

Searcher.propTypes = {
  onClose: PropTypes.func.isRequired,
  literals: PropTypes.object.isRequired,
  q: PropTypes.string.isRequired,
  results: PropTypes.array.isRequired,
  setQueryString: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  app: PropTypes.object.isRequired,
  canLoadMore: PropTypes.bool.isRequired,
  viewUserProfile: PropTypes.func.isRequired,
};

export default Searcher;



// WEBPACK FOOTER //
// ./src/components/Searcher/components/Searcher.jsx